// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sl-2";
export var chatLink = "_sl-0";
export var chatText = "_sl-1";